/**
 * Lock the page scroll
 * this will apply styles in order to stop all layout shifts, and will
 * add a fake scrollbar over the page in order to "disable" scroll
 * @param {boolean} lock
 * @returns
 */
export const lockScroll = (lock = false) => {

	let scrollbarWidth = window.innerWidth - document.body.clientWidth;
	let pseudoScrollbar = document.querySelector("#pseudo-scrollbar");

	if(lock === true) {

		if(!pseudoScrollbar) createScrollbar(scrollbarWidth);

		// document.body.style.height = `${window.innerHeight}px`; // TBD ON THIS, WAS A QUICK FIX
		document.body.style.width = `${document.body.clientWidth}px`;
		document.body.style.overflow = "hidden";
		document.body.style.marginRight = `${scrollbarWidth}px`;
		// document.body.style.transform = "translateX(0)"; // TODO: Figure out workaround here

		return;
	}

	if(pseudoScrollbar) pseudoScrollbar.remove();

	document.body.style.width = null;
	document.body.style.overflow = null;
	document.body.style.marginRight = null;
	document.body.style.transform = null;
}

const createScrollbar = (scrollbarWidth) => {

	/** Psuedo element to show disabled scrollbar */
	let el = document.createElement("textarea");

	el.id = "pseudo-scrollbar";

	Object.assign(el.style, {
		"overflow-y": "scroll",
		"overflow-x": "hidden",
		"border": "none",
		"outline": "none",
		"resize": "none",
		"position": "fixed",
		"pointer-events": "none",
		"background": "none",
		"top": "0",
		"right": "0",
		"bottom": "0",
		"left": "0",
		"z-index": "99999999999"
	});

	document.body.appendChild(el);
}
